/**
 * @method removeWidow
 *
 * @param  {String} input
 *         The string to evaluate.
 *
 * @return {String} The de-widowed string.
 */
export function removeWidow(input) {
  if (!input || typeof input !== 'string') {
    return input
  }

  // Match a white space char (\s) next to a group of non white space characters (\S+ 0 max 20 chars) at the end ($)
  // of the provided input and replace the space with a unicode representation of &nbsp
  // (to get around angular sanitizing).
  return input.replace(/\s(\S{1,20})$/, '\u00A0$1')
}
